import React, { useRef, useEffect } from 'react'
import _ from 'lodash'
import cn from 'classnames'
import MonthSelect from './MonthSelect'
import LogoutBtn from './LogoutBtn'
import Linky from './Linky'

let AdminNavbar = ({
  searchVal,
  setSearchVal,
  setLoggedIn,
  month,
  setMonth,
  setPage,
  view,
  setView,
  adminPermissions,
}) => {
  let { fullAccess } = adminPermissions
  let searchBox = useRef(null)

  useEffect(() => {
    let jumpToSearch = e => {
      e.stopPropagation()

      if (e.key === '/' && e.target.tagName.toLowerCase() !== 'input') {
        e.preventDefault()
        searchBox.current.focus()
      }
    }

    window.addEventListener('keydown', jumpToSearch)

    return () => window.removeEventListener('keydown', jumpToSearch)
  }, [])

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      {/* <span className="navbar-brand">
        <img
          src="https://evergreenonlineleads.com/wp-content/uploads/2018/12/LogoWhite.png"
          height={20}
          alt=""
        />
      </span> */}
      <ul className="navbar-nav mr-auto">
        {[
          { route: 'partners', allowed: [fullAccess] },
          { route: 'clients', allowed: [true] },
          { route: 'leads', allowed: [true] },
          { route: 'reports', allowed: [true] },
          { route: 'billing', allowed: [fullAccess] },
          { route: 'dueDiligence', allowed: [fullAccess] },
        ]
          .filter(r => _.some(r.allowed))
          .map(({ route }) => (
            <li
              key={route}
              className={cn('nav-item', { active: view === route })}
            >
              <Linky className="nav-link" onClick={() => setView(route)}>
                {_.startCase(route)}
              </Linky>
            </li>
          ))}
      </ul>
      <div className="form-inline ml-auto">
        {(view === 'leads' || view === 'clients') && (
          <input
            ref={searchBox}
            className="form-control mr-2"
            placeholder="Search"
            value={searchVal}
            style={{ minWidth: '280px' }}
            onChange={e => {
              setSearchVal(e.target.value)
              setPage(0)
            }}
          />
        )}
        {(view === 'leads' || view === 'reports') && (
          <MonthSelect month={month} setMonth={setMonth} />
        )}
      </div>
      <LogoutBtn setLoggedIn={setLoggedIn} />
    </nav>
  )
}

export default AdminNavbar
